import { Sheet, SheetProps } from '../sheet/sheet';

export const FullScreenSheet: React.FC<Omit<SheetProps, 'snapPoints' | 'snapPointsMode'>> = ({
  children,
  ...props
}) => {
  const snapPoints = ['90%'];

  return (
    <Sheet {...props} snapPoints={snapPoints}>
      {children}
    </Sheet>
  );
};

FullScreenSheet.displayName = 'FullScreenSheet';
